export default "__VITE_ASSET__BO_i5eVO__"